import React, { useState } from 'react';
import styles from './CircleCheckbox.module.css';

const CircleCheckbox = ({ color = 'gray', checked: defaultChecked = false, onChange }) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleCheckboxClick = () => {
    setChecked(!checked);
    if (onChange) onChange(!checked);
  };

  return (
    <div
      className={`${styles['circle-checkbox']} ${styles[color]} ${checked ? styles.checked : ''}`}
      onClick={handleCheckboxClick}
    >
      <input type="checkbox" checked={checked} readOnly />
    </div>
  );
};

export default CircleCheckbox;
